import { Radio } from 'antd'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function SignificantGroups({ value, onChange = () => null }) {
  const { t } = useTranslate()

  const options = [
    { label: t('All'), value: 'all' },
    { label: t('Significant'), value: 'significant' },
    { label: t('Non-significant'), value: 'insignificant' },
  ]

  const radioGroupProps = {
    defaultValue: 'all',
    options,
    optionType: 'button',
    buttonStyle: 'solid',
  }

  if (value) {
    radioGroupProps.value = value
    radioGroupProps.onChange = (e) => {
      onChange(e.target.value)
    }
  }

  return (
    <Styled className="significant-groups-component">
      <Radio.Group {...radioGroupProps} />
    </Styled>
  )
}
